import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { Typography as MuiTypography } from "@mui/material";

export const AutocompleteOption = ({ option, inputValue, state }) => {
  const parts = getMatchedParts(state, inputValue);

  const { key, ...optionProps } = option;

  return (
    <li
      key={key}
      {...optionProps}
      sx={{
        padding: "4px 16px",
        lineHeight: "18px",
      }}
    >
      <div
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>
          {parts?.map((part, index) => {
            return (
              <MuiTypography
                key={index}
                sx={{
                  fontWeight: part.highlight ? 700 : 400,
                }}
                variant="body2"
                component="span"
              >
                {part.text}
              </MuiTypography>
            );
          })}
        </span>
      </div>
    </li>
  );
};

const getMatchedParts = (state, inputValue) => {
  let matches;

  if (!!state.isDummy) {
    return [
      {
        highlight: false,
        text: state.displayText,
      },
    ];
  }

  if (state.value) {
    matches = match(state.displayText, inputValue, {
      insideWords: true,
      findAllOccurrences: true,
    });
    return parse(state.displayText, matches);
  }
};
